<template>
  <div class="cmp-header-wrap" :class="{'mobile': _isMobile, 'pc': !_isMobile}">
    <div class="cmp-header" :class="{'home': activeMenu, 'gray': showGoTop}">
      <div class="header-box">
        <div class="header-left">
          <img class="logo g-pointer" src="~@images/logo.png" alt @click="goHome">
          <!-- <h1 @click="goHome">长春博物馆</h1>
          <p class="eng">CHANGCHUN MUSEUM</p> -->
        </div>

        <!-- text-color="#000"
        active-text-color="#9C4040" -->
        <!-- <el-menu-item class="m-menu-top" :index="item.path" :key="index">{{item.meta.title}}</el-menu-item> -->
        <el-menu :default-active="activeMenu" :unique-opened="true" class="el-menu-top" mode="horizontal" @select="handleSelect" background-color="transparent" :router="true">
        <!-- <el-menu :default-active="activeMenu" class="el-menu-top" mode="horizontal" @select="handleSelect" background-color="transparent"> -->
          <template v-for="(item, index) in menus.slice(0,9)">
            <el-menu-item class="m-menu-top" :index="item.path" :key="index"
              v-if="!item.children">
              <p style="display: flex;flex-direction: column;margin-bottom: 5px;">
                <span class="name">{{item.title}}</span>
                <span class="eng">{{item.enName}}</span>
              </p>
            </el-menu-item>

            <template v-else>
              <el-submenu popper-class="dl-wrapper" :index="item.path" class="my-submenu" @click.native="handleSelectMenu(item)" :key="index"
                :popper-append-to-body="true">
                <template slot="title">{{item.title}}</template>
                <div class="aaa" style="display: flex;">
                  <el-menu-item :index="it.path" :key="i" v-for="(it, i) in item.children">
                    <span class="span-wrapper" :class="{'active': it.path == activePath}"
                      @click="subMenuClk(it)"><span>{{it.title}}</span>
                      <!-- <img src="../../assets/images/icon_open@2x.png"alt=""> -->
                      <!-- <span> activePath:{{ activePath }}</span> -->
                    </span>
                  </el-menu-item>
                </div>
              </el-submenu>
            </template>
          </template>

          <!-- <el-submenu index="2" v-show="menus.length>9">
            <template slot="title">更多</template>
            <el-menu-item
              class="m-menu-top"
              :index="item.path"
              :key="index"
              v-for="(item, index) in menus.slice(9)"
            >{{item.title}}</el-menu-item>
          </el-submenu> -->
        </el-menu>
        <div class="operate">
          <i class="el-icon-search"></i>
          <router-link tag="div" :to="'/search'" class="btn-search" style="flex-direction: column;cursor: pointer;">
            <i class="el-icon-search" style="margin-right: 0;"></i>
            <span class="eng">Search</span>
          </router-link>

          <!-- <router-link tag="a" :to="'/search'" class="btn-search"><i class="el-icon-search"></i> </router-link> -->

          <!-- <router-link tag="a" :to="'/video'" class="btn-search btn-video"><i class="el-icon-search"></i> </router-link> -->

          <router-link tag="a" :to="'/search'" class="btn-search btn-menu"><i class="el-icon-search"></i> </router-link>

          <!-- <cmpNoticeCenter ref="cmpNoticeCenter"></cmpNoticeCenter> -->

          <!-- <i class="el-icon el-icon-search g-pointer" v-if="!showSearch" @click="showSearch=true;blurFocus=true;"></i> -->
          <!-- <i class="el-icon el-icon-search g-pointer" v-if="!showSearch" @click="showSearchBox"></i> -->

          <el-input ref="customerInput" suffix-icon="el-icon-search"
            style="width:300px;position:absolute;right: 100px;top: 10px;z-index: 2;" placeholder="输入关键字"
            @keyup.enter.native="goSearch" @blur="showSearch=false" v-if="showSearch" v-model="key"></el-input>

          <!-- <el-upload
            class="g-inline-block"
            action="/singleMuseum/user/updateUserImg"
            accept="image/*"
            :data="configData"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess"
          >
            <img
              class="g-pic small"
              :src="$store.state.user.headImg || ''"
              alt
              :onerror="defaultHeadImg"
            >
          </el-upload> 
          
          <label class="person ml-10">
            <span class="name m-assist ell">{{$store.state.user.userName}}</span>
          </label>
          
          <span class="m-assist ml-20 g-pointer" @click="loginOut">退出</span>-->

          <!-- 菜单 -->

          <!-- <div class="login g-pointer" @click="goLogin" v-if="!$store.state.user.userName"><span>登录</span></div>
          <el-dropdown trigger="click" @command="handleOperate" v-else>
            <div class="head-img-box">
              <img :src="$store.state.user.headImg || ''"
                alt
                :onerror="defaultHeadImg"
              >
              <label class="person ml-10">
                <span class="name m-assist ell">{{$store.state.user.userName}}</span>
              </label>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">个人中心</el-dropdown-item>
              <el-dropdown-item command="2">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import '@assets/css-mobile/common.scss'
export default {
  name: 'Header',
  data() {
    return {
      activeIndex: '1',
      showGoTop: false,
      blurFocus: true,
      activePath: '',
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      // activeMenu: this.$route.path,
      activeMenu: '',
      key: '',
      showSearch: false,
      menus: [
        {
          title: '首页',
          enName: 'Home',
          path: '/home'
        },
        {
          title: '陈列展览',
          enName: 'Exhibition',
          path: '/exhibition',
          // children: [
          //   {
          //     title: '常设展览',
          //     path: '/exhibition',
          //   },
          //   {
          //     title: '全景展厅',
          //     path: '/exhibition?pageType=3',
          //   }
          // ]
        },
        {
          title: '馆藏精品',
          enName: 'Collection',
          path: '/collect',
          // children: [
          //   {
          //     title: '馆藏精品',
          //     path: '/collect',
          //   },
          //   {
          //     title: '藏品征集',
          //     path: '/collect?pageType=2',
          //   },
          //   {
          //     title: '古建遗迹',
          //     path: '/collect?pageType=3',
          //   },
          // ]
        },
        {
          title: '社会教育',
          enName: 'Education',
          path: '/activity',
          // children: [
          //   {
          //     title: '社教活动',
          //     path: '/activity',
          //   },
          //   {
          //     title: '游学活动',
          //     path: '/activity?pageType=2',
          //   },
          //   {
          //     title: '讲座',
          //     path: '/activity?pageType=3',
          //   },
          //   {
          //     title: '手工',
          //     path: '/activity?pageType=4',
          //   },
          //   {
          //     title: '其他',
          //     path: '/activity?pageType=5',
          //   }
          // ]
        },
        
        // {
        //   title: '资讯动态',
        //   enName: 'Information',
        //   path: '/information',
        //   // children: [
        //   //   {
        //   //     title: '关于我们',
        //   //     path: '/information',
        //   //   },
        //   //   {
        //   //     title: '博物馆章程',
        //   //     path: '/information?pageType=2',
        //   //   },
        //   //   {
        //   //     title: '新闻动态',
        //   //     path: '/information?pageType=3',
        //   //   },
        //   //   {
        //   //     title: '机构设置',
        //   //     path: '/information?pageType=4',
        //   //   },
        //   //   {
        //   //     title: '联系我们',
        //   //     path: '/information?pageType=5',
        //   //   }
        //   // ]
        // },
        // {
        //   title: '视频资源',
        //   enName: 'Video',
        //   path: '/video',
        // },
        // {
        //   title: '文创产品',
        //   enName: 'Cultural & Creative Products',
        //   path: '/product'
        // },
        {
          title: '通知公告',
          enName: 'Notice',
          path: '/notice',
        },
        {
          title: '关于我们',
          enName: 'About Us',
          path: '/about',
        },
        // {
        //   title: '公众服务',
        //   path: '/service',
        //   // children: [
        //   //   {
        //   //     title: '志愿者',
        //   //     path: '/service',
        //   //   },
        //   //   {
        //   //     title: '失物登记',
        //   //     path: '/service?pageType=2',
        //   //   },
        //   //   {
        //   //     title: '观众留言',
        //   //     path: '/service?pageType=3',
        //   //   }
        //   // ]
        // },



        // {
        //   title: '参观',
        //   path: '/visit',
        //   // children: [
        //   //   {
        //   //     title: '景区地图',
        //   //     path: '/visit',
        //   //   },
        //   //   {
        //   //     title: '参观预约',
        //   //     path: '/visit?pageType=2',
        //   //   },
        //   //   {
        //   //     title: '馆内服务',
        //   //     path: '/visit?pageType=3',
        //   //   },
        //   //   {
        //   //     title: '位置周边',
        //   //     path: '/visit?pageType=4',
        //   //   }
        //   // ]
        // },
        // {
        //   title: '文化dele',
        //   path: '/culture',
        // },
      ]
    }
  },
  watch: {
    
    $route: {
      handler(to, from) {
        this.activePath = to.fullPath
        this.activeMenu = '/' + this.$route.path.split('/')[1]
        // console.log(11134, this.activeMenu)
    　},
      immediate: true
    },
    // $route(to, from) {
    //   // if (to.path.indexOf('museum') == -1) {
    //   //   this.activePath = ""
    //   // } else {
    //   // }
    //   this.activePath = to.fullPath
    //   this.activeMenu = '/' + this.$route.path.split('/')[1]
    //   console.log(11134, this.activeMenu)
    // },
  },
  methods: {
    subMenuClk(it) {
      this.activePath = it.path
      // console.log(this.activePath)
    },
    handleOperate(val) {
      if (val === '1') {
        this.$router.push({ path: '/person' })
      } else if (val === '2') {
        this.loginOut()
      }
    },
    goHome() {
      this.$router.push({
        path: '/home'
      })
    },
    goLogin() {
      this.$router.push({
        path: '/login'
      })
    },
    goSearch() {
      console.log('搜索', this.key)
    },
    // 显示搜索框
    showSearchBox() {
      this.showSearch = true
      this.$nextTick(() => {
        this.$refs.customerInput.$el.querySelector('input').focus()
      })
    },
    handleSelect(key) {
      this.$router.push(key)
    },
    handleSelectMenu(obj){
      this.activeMenu = obj.children[0].path
      this.handleSelect(obj.children[0].path)
    },
    loginOut() {
      this.$store.dispatch('LoginOut')
      this.$router.push({ path: '/login' })
    },
    handleScroll(e) {
      // console.log(e.target.scrollTop)
      let scrollTop = document.documentElement.scrollTop
      // let scrollTop = e.target.scrollTop
      // console.log(scrollTop)
      // if(scrolltop > window.innerHeight){
      if(scrollTop > 100){
        this.showGoTop = true
      }else{
        this.showGoTop = false
      }
      
    },
    // goTop() {
    //   window.scrollTo({
    //     top: 0
    //   })
    // }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true)
  }
}
</script>

<style lang="scss" scoped>
.cmp-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  // padding: 0 80px;
  width: 100%;
  height: $headerHeight;
  // background: transparent;
  // background: linear-gradient(180deg, rgba(0,0,0,0.50) 0%, rgba(0,0,0,0.00) 100%);
  background: #fff;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  &.gray {
    // background: #1C1E24;
    background: #fff;
  }
  // box-shadow: 0 3px 8px 2px #d5dee640;
  // box-shadow: 0 3px 8px 2px #f0f4f740;
  // &.home {
  //   position: absolute;
  //   background: rgba($color: #000, $alpha: 0.5);
  //   /deep/ .el-menu--horizontal > .el-menu-item,
  //   /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  //     color: #fff;
  //   }
  //   .operate {
  //     color: #fff;
  //     .name{
  //       color: #fff;
  //     }
  //   }
  // }
  .header-box {
    position: relative;
    // width: 1600px;
    width: 100%;
    padding: 0 160px 0 140px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    // justify-content: space-around;
    justify-content: space-between;
    align-items: center;
  }
  .btn-search {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    // height: 50px;
    // line-height: 50px;
    color: #0E0E0E;
    cursor: pointer;
    i {
      font-size: 22px;
      margin-right: 30px;
      width: 30px;
      height: 31px;
      background: url(~@images/icon_search.png) no-repeat center center;
      background-size: 100% 100%;
    }
    .eng {
      color: rgba($color: #0E0E0E, $alpha: 0.8);
      font-size: 16px;
      text-wrap: nowrap;
    }
    &.btn-video {
      i {
        background: url(~@images/icon_video.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
    &.btn-menu {
      display: none;
      i {
        background: url(~@images/icon_expand@2x.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
    &:hover {
      opacity: 0.7;
    }
  }
  .header-left {
    display: flex;
    // align-items: center;
    flex-direction: column;
    // padding-left: 20px;
    margin-right: 30px;
    .logo {
      width: 265px;
      // width: 319px;
      // height: 91px;
    }
    h1 {
      width: 260px;
      display: inline-block;
      color: #fff;
      font-family: '黑体';
      font-size: 28px;
      // font-weight: bold;
      line-height: 35px;
      margin-bottom: 0;
      letter-spacing: 11.5px;
    }
    .eng {
      color: #fff;
      font-size: 16px;
    }
  }
  .head-pic {
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .el-menu-top {
    flex: 1;
    border: none;
    display: flex;
    justify-content: center;
  }
  .operate {
    // padding-right: 40px;
    // width: 200px;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #000;
    .el-icon {
      margin-right: 36px;
    }
    .head-img-box {
      display: inline-block;
      outline: none;
      cursor: pointer;
      img {
        width: 25px;
        height: 25px;
        vertical-align: middle;
        border-radius: 100%;
      }
    }
    .person {
      cursor: pointer;
      .name {
        max-width: 90px;
        display: inline-block;
        position: relative;
        top: 6px;
      }
      // img {
      //   margin-right: 10px;
      //   display: inline-block;
      //   width: 40px;
      //   height: 40px;
      //   vertical-align: middle;
      //   border-radius: 100%;
      // }
    }
  }
}
// 重置element-ui样式
.cmp-header {
  .name {
  }
  .eng {
    font-size: 16px;
    color: rgba(#0E0E0E, 0.8);
  }
  /deep/ .el-menu--horizontal > .el-menu-item,
  /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    // min-width: 100px;
    height: 100px;
    // line-height: 100px;
    line-height: 30px;
    text-align: center;
    // border-width: 4px;
    border-width: 0;
    // border-bottom: none;
    // border-bottom: solid 2px $primary;
    @include menuTop;
    &:after {
      display: block;
      content: '';
      width: 0;
      height: 2px;
      background: #880000;
      transition: all .2s ease-in;
      position: relative;
      top: -3px;
    }
    &.is-active {
      color: #0E0E0E;
      border-color: #0E0E0E;
      &:after {
        width: 100%;
      }
    }
    
  }
  /deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    color: #fff;
    border-width: 0;
    &:after {
      width: 100%;
    }
  }

  /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
  /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
    background-color: transparent !important;
  }
  /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    // color: #fff;
    color: #0E0E0E;
  }

  // 二级菜单样式
  /deep/ .el-menu--horizontal {
    .el-menu-item {
      padding: 0;
      margin: 0 30px;
    }
    .el-submenu__title {
      padding: 0;
      margin: 0 30px;
      a {
        display: block;
        line-height: 50px;
        // color: #000;
        color: rgba(255, 255, 255, 0.7);
        &:hover {
          background-color: transparent !important;
          color: #fff;
        }
        &.router-link-active {
          color: #fff;
        }
      }
      i {
        display: none;
      }
      &:hover {
        background-color: transparent !important;
        color: #fff;
      }

      &:after {
        display: block;
        content: '';
        width: 0;
        height: 2px;
        background: #fff;
        transition: all .2s ease-in;
        position: relative;
        top: -3px;
      }
    }

    .el-submenu.is-active {
      color: #fff;
      // border-bottom: solid 2px #fff;
      @include menuTopActive;
      .el-submenu__title {
        border-color: #fff;
        a {
          color: #fff;
        }
      }
    }
  }

  .el-icon-search {
    position: relative;
    font-size: 22px;
    &:before {
      color: #979797;
      display: none;
    }
    &:after {
      display: none;
      // position: absolute;
      // right: -18px;
      // top: 2px;
      // display: block;
      // content: '';
      // width: 1px;
      // height: 20px;
      // background: rgba($color: #979797, $alpha: 0.2);
    }
  }
}

// 下拉框二级菜单
/deep/ .my-submenu {
  .el-menu--horizontal {
    background: transparent;
    .el-menu--popup {
      display: flex;
      box-shadow: none;
      margin-top: 13px;
      .el-menu-item {
        margin: 0;
        padding: 0 30px;
        min-width: auto;
        color: #fff;
        font-size: 16px;
        position: relative;
        z-index: 5;
        border-bottom: 1px solid rgba($color: #121100, $alpha: 0.2);
        &:hover {
          background-color: transparent !important;
          color: #fff;
        }
        // TODO
      }
    }
  }
  &:after {
    display: none;
    // display: block;
    // opacity: 0;
    // transition: all 2s;
    // content: '';
    // width: 100vw;
    // height: 50px;
    // position: fixed;
    // left: 0;
    // top: 120px;
    // background: rgba(178, 149, 80, 0.6);
    // z-index: 0;
  }
  &.is-opened {
    &:after {
      display: block;
      // opacity: 1;
    }
  }
}
// // 下拉框二级菜单
// /deep/ .el-menu--horizontal {
//   .el-menu--popup {
//     .el-menu-item {
//       padding: 0 30px;
//       &:hover {
//         background-color: transparent !important;
//         color: $primary;
//       }
//       // &.is-active {
//       //   color: $primary;
//       // }
//       // TODO
//       &.is-active {
//         color: #909399;
//       }
//     }
//   }
// }
</style>

